import styles from './ccf-interaction-search-customers-tab.module.scss';
import {
  CcfBox,
  CcfDeboucedInput,
  CcfInteractionSearchColumnIcon,
  CcfSupervisorFilterIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { makeStyles } from '@mui/styles';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import { interactionSearchData } from '../../ccf-interaction-search-cases-tab/ccf-interaction-search-cases-tab/ccf-interactionSearch-staticData';
import { fomatToDateString, fomatToTimeString } from '@nice-ccf/core-sdk';
import {
  Button,
  InputAdornment,
  useTheme,
  useMediaQuery,
  Theme,
} from '@mui/material';
import { Search } from '@mui/icons-material';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
/* eslint-disable-next-line */
export interface CcfInteractionSearchCustomersTabProps {}

const useStyles = makeStyles({
  root: {
    '& .MuiDataGrid-root': {
      border: '1px solid rgba(251, 252, 252, 1)',
      Height: '330px',
    },

    '& .MuiDataGrid-columnHeaderTitleContainer': {
      padding: '0px',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: '12px',
      lineHeight: '16px',
      textTransform: 'uppercase',
      color: '#526B79',
    },
    '& .MuiDataGrid-columnsContainer': {
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      boxShadow: '0px 3px 4px rgba(0, 0, 0, 0.08)',
    },
    '& .styledrows': {
      height: '36px',
      background: '#FFFFF',
      border: '1px solid #D2D8DB',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: '400',
      fontSize: '13px',
      lineHeight: '18px',

      color: '#333333',

      /* Inside auto layout */
    },
    // '& .MuiDataGrid-window': {
    //   height: '285px',
    //   overflowY: 'scroll',
    // },
  },
  searchInput: {
    '&.MuiOutlinedInput-inputAdornedEnd': {
      paddingBottom: '7.5px',
    },
  },
});

export const columns = [
  {
    field: 'customerName',
    headerName: 'Customer Name'.toUpperCase(),
    flex: 1,
    maxWidth: 300,
    renderCell: (params: any) => {
      return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
          <AccountBoxIcon style={{ color: 'grey' }} />
          <CcfTypography>{params.row.customerName}</CcfTypography>
        </div>
      );
    },
  },
  {
    field: 'lastUpdated',
    headerName: 'last activity'.toUpperCase(),
    flex: 1,
    maxWidth: 310,
  },
  {
    field: 'inbound',
    headerName: 'inbound'.toUpperCase(),
    flex: 1,
    maxWidth: 270,
  },
  {
    field: 'outbound',
    headerName: 'outbound'.toUpperCase(),
    flex: 1,
    maxWidth: 340,
  },
];
/**
 * CcfInteractionSearchThreadsTab - used to display threads in interaction search tabs
 * @param props -? - CcfInteractionSearchThreadsTabProps
 * @example - <CcfInteractionSearchThreadsTab />
 */
export function CcfInteractionSearchCustomersTab(
  props: CcfInteractionSearchCustomersTabProps
) {
  const classes = useStyles();
  const [rowData, setRowData]: any = useState([]);
  const theme: Theme = useTheme();

  const isSmView = useMediaQuery(theme.breakpoints.down('xl'), { noSsr: true });

  useEffect(() => {
    const rd = interactionSearchData.data.map((x, i) => {
      return {
        id: i,
        lastUpdated:
          `${new Date(x.endUser.updatedAt)}` !== 'Invalid Date'
            ? fomatToDateString(new Date(x.endUser.updatedAt)) +
              ' ' +
              fomatToTimeString(new Date(x.endUser.updatedAt))
            : '',
        customerName: `${x.authorEndUserIdentity.firstName} ${x.authorEndUserIdentity.lastName}`,
        inbound: x.endUser.messageStatistics.inbound,
        outbound: x.endUser.messageStatistics.outbound,
      };
    });
    setRowData(rd);
  }, []);

  return (
    <CcfBox
      id={`agent_interactionSearch_customers_tab_container`}
      style={{ height: '100%', width: '100%' }}
    >
      {' '}
      <CcfBox className={styles.tableBlock}>
        <CcfBox className={styles.tableHeader}>
          <CcfBox
            className={styles.searchBoxSection}
            sx={isSmView ? { width: '70%' } : { width: '90%' }}
          >
            <CcfBox className={styles.searchBox}>
              <CcfDeboucedInput
                id="agent_interactionSearch_customers_tab_searchContainer"
                size="small"
                style={{
                  background: 'white',
                }}
                className={classes.searchInput}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <Search htmlColor="grey" />
                    </InputAdornment>
                  ),
                }}
                placeholder="Search content"
                variant="outlined"
                fullWidth
                delay={1500}
              />
            </CcfBox>
          </CcfBox>
          <CcfBox
            id={`agent_interactionSearch_customers_tab_filtersContainer`}
            className={styles.filterIconBlock}
            sx={isSmView ? { width: '30%' } : { width: '8%' }}
          >
            <Button
              sx={{
                gap: '7px',
                padding: 0,
                width: '24px',
                height: '38px',
                minWidth: 'auto',
                '&.MuiButtonBase-root:hover': { bgcolor: 'transparent' },
              }}
              id="agent_interactionSearch_filters_popOver_button"
            >
              <CcfSupervisorFilterIcon style={{ fontSize: 14 }} />
              <CcfTypography className={styles.filtersHeader}>
                Filters
              </CcfTypography>
            </Button>
          </CcfBox>
        </CcfBox>
        <CcfBox style={{ height: '495px', overflowY: 'scroll' }}>
          <CcfBox
            style={{
              height: 'inherit',
              backgroundColor: '#FFFF',
              overflowY: 'hidden',
              borderTop: '1px solid #E1E1E1',
            }}
            id={`agent_interactionSearch_customers_tab_dataGridContainer`}
          >
            {' '}
            <DataGrid
              classes={{ root: classes.root }}
              rows={rowData}
              columns={columns}
              rowHeight={40}
              pageSize={10}
              headerHeight={40}
              pagination
              rowsPerPageOptions={[5, 10, 25]}
              getRowClassName={(params: any) => `styledrows`}
              sx={{
                '& .MuiDataGrid-columnHeaderTitle': {
                  color: '#3F5C69',
                  fontWeight: '600',
                  fontSize: '12px',
                  fontFamily: 'Open Sans',
                },
              }}
            />
          </CcfBox>
        </CcfBox>
      </CcfBox>
    </CcfBox>
  );
}

export default CcfInteractionSearchCustomersTab;
